module.exports = __webpack_public_path__ + "static/media/FontAwesome.0fbd35c2.ttf";